import { ImagePreview, Dialog  } from 'vant';
const ua = window.navigator.userAgent;
const isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
const isWechat = /micromessenger/i.test(ua);
const gobalFunc = {
  go(path, isReplace = false) {
    isReplace ? this.$router.replace(path) : this.$router.push(path);
  },
  goBack(detail = -1) {
    const long = window.history.length;
    if (long > 1) {
      this.$router.go(detail);
    } else {
      window.goBack();
    }
  },
  laterGoBack() {
    setTimeout(() => {
      this.goBack();
    }, 1500);
  },
  ToastUni(message) {
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      uni.webView.postMessage({
        data: {
          action: 'Toast',
          data: message
        }
      });
    } else {
      this.$toast(message);
    }
  },
  ToastClear() {
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      uni.webView.postMessage({
        data: {
          action: 'ClearLoading'
        }
      });
    } else {
      this.$toast.clear();
    }
  },
  Loading(message) {
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      uni.webView.postMessage({
        data: {
          action: 'Loading',
          data: message || '加载中...' // 加载信息
        }
      });
    } else {
      this.$toast.loading({
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true,
        message: message || '加载中...'
      });
    }
  },
  Dialog({title,message,success,error}) {
    return Dialog.confirm({
      title: title,
      message: message,
      className: 'my-dialog',
      overlayStyle: {
        background: '#00000000'
      }
    })
  },
  // Dialog({title,message,success,error}) {
  //   if (navigator.userAgent.indexOf('uni-app') > -1) {
  //     const dialog = new Promise((resolve) => {
  //       uni.webView.postMessage({
  //         data: {
  //           action: 'Dialog',
  //           data: {
  //             title: title, // 标题名
  //             message: message, // 具体内容，非必填
  //             success: success, // 确认回调方法名
  //             error: error // 取消回调方法名
  //           }
  //         }
  //       });
  //       window[success] = function() {
  //         window[success] = '';
  //         window[error] = '';
  //         resolve();
  //       };
  //       window[error] = function() {
  //         window[success] = '';
  //         window[error] = '';
  //         Promise.reject();
  //       };
  //     });
  //     return dialog;
  //   } else {
  //     return Dialog.confirm({
  //       title: title,
  //       message: message,
  //       className: '',
  //       overlayStyle: {
  //         background: '#00000000'
  //       }
  //     })
  //   }
  // },
  uploadImage({url, max, maxSize, data, fileField, success, error}) {
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      const upload = new Promise((resolve) => {
        // eslint-disable-next-line
        uni.webView.postMessage({
          data: {
            action: 'uploadImage',
            data: {
              url: url, // 上传地址
              max: max, // 最大可选文件数
              maxSize: maxSize, // 最大文件大小，最大文件大小限制为5MB（5 * 1024 * 1024字节）
              data: data, // 除file对象外formData所需对象<键值对>
              fileField: fileField, // file对象所属字段名
              success: success, // 确认回调方法名success(list[res<upload接口返回对象>])
              error: error // 失败回调方法名error(msg<报错信息字符串>)
            }
          }
        });
        window[success] = function(jsonData) {
          const json = JSON.parse(jsonData);
          window[success] = '';
          window[error] = '';
          resolve(json);
        };
        window[error] = function(message) {
          window[success] = '';
          window[error] = '';
          Promise.reject(new Error(message));
        };
      });
      return upload
    } else {
      throw new Error('环境异常') 
    }
  },
  uploadFile({url, max, maxSize, data, fileField, success, error}) {
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      const upload = new Promise((resolve) => {
        // eslint-disable-next-line
        uni.webView.postMessage({
          data: {
            action: 'uploadFile',
            data: {
              url: url, // 上传地址
              max: max, // 最大可选文件数
              maxSize: maxSize, // 最大文件大小，最大文件大小限制为5MB（5 * 1024 * 1024字节）
              data: data, // 除file对象外formData所需对象<键值对>
              fileField: fileField, // file对象所属字段名
              success: success, // 确认回调方法名success(list[res<upload接口返回对象>])
              error: error // 失败回调方法名error(msg<报错信息字符串>)
            }
          }
        });
        window[success] = function(jsonData) {
          const json = JSON.parse(jsonData);
          window[success] = '';
          window[error] = '';
          resolve(json);
        };
        window[error] = function(message) {
          window[success] = '';
          window[error] = '';
          Promise.reject(new Error(message));
        };
      });
      return upload
    } else {
      throw new Error('环境异常') 
    }
  },
  getUserInfo({success, error}) {
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      const getInfo = new Promise((resolve) => {
        // eslint-disable-next-line
        uni.webView.postMessage({
          data: {
            action: 'getUserInfo',
            data: {
              success: success, // 确认回调方法名success({name: '昵称\用户名', avatar: '头像', bgImg: '背景图'}对象序列化字符串)
              error: error // 失败回调方法名error(msg<报错信息字符串>)
            }
          }
        });
        window[success] = function(jsonData) {
          const json = JSON.parse(jsonData);
          window[success] = '';
          window[error] = '';
          resolve(json);
        };
        window[error] = function(message) {
          window[success] = '';
          window[error] = '';
          Promise.reject(new Error(message));
        };
      });
      return getInfo
    } else {
      return this.$store.dispatch('getData', {
        url: '/api/http/user/info'
      });
    }
  },
  updateUserInfo({bgImg}) {
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      uni.webView.postMessage({
        data: {
          action: 'updateUserInfo',
          data: {
            bgImg: bgImg
          }
        }
      });
    }
  },
  previewImg(list, index, closeable = true) { // 预览图片
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      uni.webView.postMessage({
        data: {
          action: 'PreviewImage',
          data: {
            current: index,
            urls: list
          }
        }
      });
    } else {
      ImagePreview({
        images: list,
        startPosition: index,
        closeable: closeable
      });
    }
  },
  download({url, fileName, error}) { // 预览图片
    if (navigator.userAgent.indexOf('uni-app') > -1) {
      uni.webView.postMessage({
        data: {
          action: 'download',
          data: {
            url: url,
            name: fileName
          }
        }
      });
    } else {
      const link = document.createElement('a');
      link.style.display = 'none';
      // 设置下载地址
      link.setAttribute('href', url);
      // 设置文件名
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  // 调用App壳通用方法
  toAppFunction(methodName, postData, cb) {
    // location.href.indexOf('ljyxapp.') > -1
    try {
      // 如果是webkit内核，则iso是最新的
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers[methodName].postMessage(postData === undefined ? {} : postData);
      } else if (isAndroid) {
        // 安卓无参数时不能传任何值
        if (postData === undefined) {
          window.android[methodName]();
        } else {
          window.android[methodName](postData);
        }
      } else {
        window[methodName](postData);
      }
    } catch (e) {
      // 壳不支持方法，降级处理
      cb && cb();
      // console.error('调用壳方法出错', e);
    }
  },
  // 判断是否有对应权限
  hasPerm(rightCode) {
    // return true;
    const person = this.$store.state.Person;
    if (!person || !person.PersonId) {
      return false;
    }
    return person.RightList.findIndex(item => item.RightCode.indexOf(rightCode) === 0) > -1;
  }
};
const install = Vue => {
  Vue.prototype.isAndroid = isAndroid;
  Vue.prototype.isWechat = isWechat;
  Object.keys(gobalFunc).forEach(key => {
    Vue.prototype[key] = gobalFunc[key];
  });
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default install;
